import { ConnectionOptions, GraphApiMethod } from '@/api/core';
import {
  CreateDispatchIssueInput,
  CreateDispatchIssueResponse,
  DispatchIssue,
  DispatchIssueRootCauseEnum,
  MutationCreateDispatchIssueBulkArgs,
} from '@/models/gen/graphql';
import createGraphApiHook, { CreateGraphApiHookHook } from '@/hooks/createGraphApiHook';

import { CreateDispatchIssue } from '@/features/IssueHistory/api/queries/CreateDispatchIssue';
import { TypedDocumentNode } from '@apollo/client';
import { getProperty } from '@/utils';
import graphApi from '@/api';

// Service Function Signature
type ServiceMethodPayload = {
  [key in keyof DispatchIssue]?: any;
}[];
interface ServiceMethod {
  (payload?: ServiceMethodPayload, options?: ConnectionOptions): Promise<CreateDispatchIssueResponse>;
}

// CreateDispatchIssue Service
export const { createDispatchIssue, useCreateDispatchIssue } = ((): {
  createDispatchIssue: ServiceMethod;
  useCreateDispatchIssue: CreateGraphApiHookHook<ServiceMethod>;
} => {
  const [fetch] = graphApi(CreateDispatchIssue).map(
    (fn: GraphApiMethod<TypedDocumentNode>): ServiceMethod =>
      async (payload?: CreateDispatchIssueInput[], options?: ConnectionOptions): Promise<CreateDispatchIssueResponse> => {
        debug.log('createDispatchIssue,createDispatchIssue.input', 'INPUT', payload);
        const values = payload?.map(
          (item: CreateDispatchIssueInput): CreateDispatchIssueInput => ({
            crewMemberGiftCardCount: item?.crewMemberGiftCardCount || 0,
            crewMemberName: item?.crewMemberName || '',
            crewMemberPhone: item?.crewMemberPhone || '',
            datetime: item?.datetime || null,
            dispatcherId: item?.dispatcherId || null,
            driverId: item?.driverId || null,
            driverPhone: item?.driverPhone || '',
            flightIssueDescription: item?.flightIssueDescription || null,
            flightLate: item?.flightLate || null,
            managerId: item?.managerId || null,
            outboundFlightInfo: item?.outboundFlightInfo || null,
            recoveryCompleted: item?.recoveryCompleted || null,
            recoveryFlightDatetime: item?.recoveryFlightDatetime || null,
            recoveryFlightNumber: item?.recoveryFlightNumber || null,
            recoveryNeeded: item?.recoveryNeeded || null,
            rootCause: item?.rootCause || null,
            rootCauseDescription: item?.rootCauseDescription || null,
            station: item?.station || null,
            taxiCost: item?.taxiCost || 0,
            taxiDetails: item?.taxiDetails || null,
            taxiUsed: item?.taxiUsed || null,
            tripId: item?.tripId || null,
            flightType: item?.flightType || null,
            pushTime: item?.pushTime || null,
            recoveryFlightName: item?.recoveryFlightName || null,
            scheduledTime: item?.scheduledTime || null,
            vehicleId: item?.vehicleId || null,
            documents: item?.documents || [],
            // Only include causedBy if rootCause is Dispatch
            causedBy: item?.rootCause === DispatchIssueRootCauseEnum.Dispatch ? item?.causedBy || [] : [],
          })
        );
        const args: MutationCreateDispatchIssueBulkArgs = {
          input: {
            values,
          },
        };
        debug.log('createDispatchIssue,createDispatchIssue.payload', 'PAYLOAD', args);
        const opts = { merge: options?.merge ? 'createDispatchIssueBulk' : undefined };
        const res = await fn(args, opts);
        debug.log('createDispatchIssue,createDispatchIssue.response', 'RESPONSE', res);
        return getProperty('createDispatchIssueBulk.output', res);
      }
  );
  const useService = createGraphApiHook(fetch);
  return {
    createDispatchIssue: fetch,
    useCreateDispatchIssue: useService,
  };
})();
